<template>
  <div class="main_area login_container">
    <div class="logo_area">
      <div class="header_logo">
        <a href="javascript:;"><img alt="" src="/static/image/logo_auth.png" /></a>
      </div>
    </div>
    <div class="big_card_container">
      <div class="card_container login_area">
        <div class="title swap">
          登录
          <span class="cancel">
            <button class="btn_auth">注册</button>
          </span>
        </div>
        <form autocomplete="off" id="login_form">
          <label class="textbox_content reglog text-center">
            <div class="error_msg" id="error_msg_response"></div>
          </label>
          <label class="textbox_content reglog">
            <input type="text" name="username" id="username" v-model="loginInfo.name" placeholder="请输入账号" maxlength="16" class="un" />
            <div class="input_title"></div>
            <div class="error_msg" id="error_msg_username"></div>
          </label>
          <label class="textbox_content reglog">
            <input type="password" name="password" v-model="loginInfo.password" id="password" placeholder="请输入密码" maxlength="15" class="pw" />
            <div class="input_title"></div>
            <div class="error_msg" id="error_msg_password"></div>
            <span toggle="#password" class="icon-eye_close toggle_password"></span>
          </label>
          <label class="textbox_content reglog" style="display: flex">
            <input style="flex: 1" type="text" name="password" v-model="loginInfo.code" placeholder="请输入验证码" maxlength="15" class="pw" />
            <img style="cursor: pointer; height: 37px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </label>
          <div class="remember_pw_section">
            <div></div>
            <div><a class="standard_link csLink" @click="$parent.openKefu">忘记密码？</a></div>
          </div>
          <div class="btn btn-block" @click="login" id="login_button">登录</div>
          <div class="back" @click="$parent.goNav('/')"><a href="javascript:;" class="standard_link">随便逛逛</a></div>
        </form>
      </div>
    </div>
    <div class="big_card_containe">
      <div class="card_container register_area">
        <div class="title swap_reslog">
          注册
          <span class="cancel">
            <button class="btn_auth">登录</button>
          </span>
        </div>
        <form autocomplete="off">
          <label class="textbox_content reglog">
            <input type="text" placeholder="请输入帐号（最少6位，英文及数字）" v-model="registerInfo.name" id="r_username" maxlength="32" class="un rinput" />
            <div class="input_title"></div>
            <div class="error_msg r_username_error"></div>
          </label>
          <label class="textbox_content reglog">
            <input type="password" placeholder="请输入密码（最少8位，英文及数字）" v-model="registerInfo.password" autocomplete="new-password" id="r_password" maxlength="32" class="pw rinput" />
            <div class="input_title"></div>
            <div class="error_msg r_password_error"></div>
            <span toggle="#r_password" class="icon-eye_close toggle_password"></span>
          </label>
          <label class="textbox_content reglog">
            <input type="password" placeholder="请再次输入账号密码" v-model="registerInfo.confirmPass" id="r_passwords" maxlength="32" class="pw rinput" />
            <div class="input_title"></div>
            <div class="error_msg r_password_error"></div>
            <span toggle="#r_passwords" class="icon-eye_close toggle_password"></span>
          </label>
          <label class="textbox_content reglog">
            <input type="text" placeholder="请输入真实姓名" v-model="registerInfo.realname" id="r_referral" value="" maxlength="32" class="rr" />
            <div class="input_title"></div>
            <div class="error_msg"></div>
            <input type="hidden" value="" />
            <input type="hidden" value="" />
          </label>
          <label class="textbox_content reglog">
            <input type="password" placeholder="请输入6位取款密码" v-model="registerInfo.paypassword" id="r_passwordss" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" class="pw rinput" />
            <div class="input_title"></div>
            <div class="error_msg r_password_error"></div>
            <span toggle="#r_passwordss" class="icon-eye_close toggle_password"></span>
          </label>
          <label class="textbox_content reglog" style="display: flex">
            <input style="flex: 1" type="text" name="password" v-model="registerInfo.code" placeholder="请输入验证码" maxlength="15" class="pw" />
            <img style="cursor: pointer; height: 37px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </label>
          <div class="btn btn-block" @click="register" id="register_button">注册</div>
          <div class="back" @click="$parent.goNav('/')"><a href="javascript:;" class="standard_link">随便逛逛</a></div>
        </form>
      </div>
      <div class="contact_cs_login" @click="$parent.openKefu"><img alt="" src="/login/m/templateimage/general/cs_login.png" /> <a class="csLink">联系客服！</a></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      loginInfo: {},
      registerInfo: {},
      type: 0,
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      pid: '',

      index: 0,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    that.pid = localStorage.getItem('pid') || '';

    if (query.type == 1) {
      //是注册
      that.type = 1;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.showTost(0, '请输入您的账号和密码！');
        return;
      }
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.loginInfo.code = null;
        that.changIndex();
        return;
      }
      that.showLoading();
      that.$apiFun.login(info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(0, res.message);
          that.loginInfo.code = null;
          that.changIndex();
          that.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.new_api_token);
          that.$store.commit('changToken');

          that.getUserInfos();
          that.$parent.openDaoTime();
        }
      });
    },
    register() {
      let that = this;
    let info = {};
      info.name = that.registerInfo.name || '';
      info.password = that.registerInfo.password || '';
      info.confirmPass = that.registerInfo.confirmPass || '';
      info.realname = that.registerInfo.realname || '';
      info.paypassword = that.registerInfo.paypassword || '';
      let code = that.registerInfo.code;

      // 用户名验证
      let namereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; //不得低于6位，以字母或数字组合！
      let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/; //以字母或数字组合！不低于8位
      var realnamereg = /^[\u0391-\uFFE5a-zA-Z·&\\s]+$/; //中英文姓名
      let paypasswordreg = /^[0-9]{6}$/; //只能是6位
      let codereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,}$/; //以字母或数字组合 不低于4位

      if (namereg.test(info.name) == false) {
        that.$parent.showTost(0, ' 用户名长度不得低于6位，以字母和数字组合！');
        return;
      }

      if (passwordreg.test(info.password) == false) {
        that.$parent.showTost(0, '密码长度最少8位！以字母和数字组合！');
        return;
      }
      if (info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (realnamereg.test(info.realname) == false) {
        that.$parent.showTost(0, '姓名格式不正确，可以是中，英文名称！');
        return;
      }

      if (paypasswordreg.test(info.paypassword) == false) {
        that.$parent.showTost(0, '支付密码长度需是6位！');
        return;
      }
      if (codereg.test(code) == false || code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.registerInfo.code = '';
        that.changIndex();
        return;
      }

      that.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      that.$apiFun
        .register(info)
        .then(res => {
          that.showTost(1, res.message);
          if (res.code == 200) {
            sessionStorage.setItem('token', res.data.api_token);
            that.$store.commit('changToken');
            that.getUserInfos();
            that.$parent.openDaoTime();
          } else {
            that.registerInfo.code = null;
            that.changIndex();

            that.hideLoading();
          }
        })
        .catch(res => {
          that.showTost(1, '网络异常，请检查当前网络后重试！');

          that.hideLoading();
        });
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    getUserInfos() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          if (userInfo.isblack == 1) {
            //黑名单
            that.hideLoading();

            that.$parent.clearUser();
            that.showTost(0, '您已被设为黑名单，暂不能登录，请联系管理员！');

            return;
          }
          if (userInfo.status == 0) {
            that.hideLoading();

            //用户被禁用
            that.$parent.clearUser();
            that.$parent.showTost(0, '该用户已被禁用，请联系管理员！');

            return;
          }
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.$parent.goNav('/');
        }
        that.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
    $(document).on('click touchend', '.register_area .swap_reslog .cancel, .login_area.deactive, .login_again', function (e) {
      e.stopPropagation();
      $('.login_area').removeClass('deactive');
      $('.register_area').removeClass('active');
    });

    $(document).on('click touchend', '.login_area .swap .cancel', function (e) {
      e.stopPropagation();
      $('.login_area').addClass('deactive');
      $('.register_area').addClass('active');
    });
    if (that.type == 1) {
      $('.login_area').addClass('deactive');
      $('.register_area').addClass('active');
    }
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/login.vue